import { DateTime } from 'luxon'

// Decisão do tech lead: data e hora, em GMT-3. Só a hora é ambígua no dia
// seguinte — e "solicitação de ontem" é exatamente o que o operador e o
// produtor precisam enxergar.
export const REQUEST_TIME_ZONE = 'America/Sao_Paulo'

/**
 * @param {string | null | undefined} iso
 * @returns {string | null} `null` quando não há horário — a tela não inventa.
 */
export function formatRequestTimestamp(iso) {
  if (!iso) return null

  const date = DateTime.fromISO(iso, { zone: REQUEST_TIME_ZONE })
  if (!date.isValid) return null

  return date.setLocale('pt-BR').toFormat("dd/MM 'às' HH:mm")
}

/**
 * Os dois horários que a solicitação carrega: reserva (`created_at`) e, quando
 * houver, retirada (`delivered_at`). Solicitação anterior à coluna vem sem
 * retirada — e fica sem, sem valor inventado.
 *
 * @param {{ created_at?: string | null, delivered_at?: string | null }} request
 * @returns {{ reservedAt: string | null, deliveredAt: string | null }}
 */
export function requestTimestamps(request) {
  return {
    reservedAt: formatRequestTimestamp(request?.created_at),
    deliveredAt: formatRequestTimestamp(request?.delivered_at)
  }
}
